var lib_core = require("lib-core");

var UploadStateMachine = require("./uploadStateMachine.js");

var TabController = require("./../tab/tabController.js");
var ProcessMessageController = require("./../processMessage/processMessageController.js");
var ErrorMessageController  = require("./../errorMessage/errorMessageController");


var UploadController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        UI_UPLOAD_PRESSED:                {id: 'ui_upload_01', name: "UI_UPLOAD_PRESSED" }
    });
};

lib_core.inherit(UploadController, lib_core.Controller);
UploadController.inject = {
    tabController : TabController,
    processMessageController : ProcessMessageController,
    errorController         :  ErrorMessageController
};

module.exports = UploadController;

UploadController.prototype.beforeLoad = function() {

    if(this.configuration && this.configuration.button) {
        this.toggleButton = this.tabController.getView().registerButton({
            name: this.configuration.button.name,
            title: this.configuration.button.title,
            sortOrder: 2,
            eventType: lib_core.GuiEvents.UI_UPLOAD_PRESSED,
            style: {
                icon: this.configuration.button.style.icon,
            },
            group: "buttons",
            position: "right"
        });
    }

    lib_core.Controller.prototype.beforeLoad.call(this);
};


UploadController.prototype.createStateMachine = function () {
    return new UploadStateMachine(this.root);
};